import React, { useState } from "react";
import { Container, Card, CardBody, CardTitle } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PieChart from "../AllCharts/apex/PieChart";
import PageGrid from "../../components/GridLayout/PageGrid";
import FieldCustomizerPanel, { useFieldCustomizer, DataTable } from "../../components/FieldCustomizer/FieldCustomizer";
import "../../components/FieldCustomizer/FieldCustomizer.css";

const REJECTION_FIELDS = [
  { value:"sn",         label:"SN"         },
  { value:"machine",    label:"Machine"    },
  { value:"rejections", label:"Rejections" },
  { value:"count",      label:"Count"      },
  { value:"percentage", label:"Percentage" },
];

const REJECTION_DEFAULT_COLS = [
  { id:"sn",         label:"SN",         field:"sn",         visible:true },
  { id:"machine",    label:"Machine",    field:"machine",    visible:true },
  { id:"rejections", label:"Rejections", field:"rejections", visible:true },
];

const REJECTION_ROWS = [
  { sn:1, machine:"IM-3", rejections:"5%",  count:12, percentage:"5%" },
  { sn:2, machine:"IM-2", rejections:"0.2%",count:1,  percentage:"0.2%" },
];

const QualityDashboard = () => {
  document.title = "Quality Dashboard | OptiMize";

  const tableFC = useFieldCustomizer("quality_rejections", [], REJECTION_DEFAULT_COLS);

  const FilterCard = (
    <Card className="h-100 mb-0">
      <CardBody>
        <div className="row g-2 align-items-end">
          <div className="col-lg-3">
            <label className="col-form-label">Select Machine</label>
            <select className="form-control"><option>Select</option><option>IM-1</option><option>IM-2</option><option>IM-3</option></select>
          </div>
          <div className="col-lg-3">
            <label className="col-form-label">From</label>
            <input className="form-control" type="date" defaultValue="2024-01-01"/>
          </div>
          <div className="col-lg-3">
            <label className="col-form-label">To</label>
            <input className="form-control" type="date" defaultValue={new Date().toISOString().split("T")[0]}/>
          </div>
          <div className="col-lg-3 d-flex align-items-end">
            <button className="btn btn-info w-100">Submit</button>
          </div>
        </div>
      </CardBody>
    </Card>
  );

  const RejectionsTable = (
    <Card className="h-100 mb-0">
      <CardBody style={{padding:0,height:"100%",overflow:"auto"}}>
        <div className="p-3 pb-0"><CardTitle>Top Machine Rejections</CardTitle></div>
        <DataTable columns={tableFC.columns} rows={REJECTION_ROWS} />
      </CardBody>
    </Card>
  );

  const RejectionPie = (
    <Card className="h-100 mb-0">
      <CardBody><CardTitle>Rejection Reasons</CardTitle><PieChart /></CardBody>
    </Card>
  );

  const widgets = [
    { id:"filter",     label:"Filters",          icon:"mdi mdi-filter-outline", defaultW:12, defaultH:4, minH:3, content:FilterCard },
    {
      id:"rejections", label:"Top Rejections",    icon:"mdi mdi-table",          defaultW:6,  defaultH:7, minH:5,
      customizer:(
        <FieldCustomizerPanel cards={[]} columns={tableFC.columns} availableFields={REJECTION_FIELDS}
          onCardsChange={()=>{}} onColumnsChange={tableFC.updateCols} onReset={tableFC.resetFields}/>
      ),
      content:RejectionsTable,
    },
    { id:"pie",        label:"Rejection Reasons", icon:"mdi mdi-chart-donut",    defaultW:6,  defaultH:7, minH:5, content:RejectionPie },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Quality Dashboard" />
          <PageGrid pageKey="quality_dashboard" widgets={widgets} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default QualityDashboard;
